import { mapActions, mapGetters } from 'vuex';
import { NOTIFICATION_TYPES } from '../config';

export default {
  beforeCreate() {
    const unwatch = this.$store.watch(
      (_, getters) => getters['currentUserModule/getCurrentUserId'],
      (newVal) => {
        if (newVal) {
          this.$broadcastClient.private(`ukasko.user.${newVal}`).listen(NOTIFICATION_TYPES.NOTIFICATION_ADD, (event) => {
            if (event?.notification) {
              this.setNewNotification(event.notification);
            }
          });

          unwatch();
        }
      }
    );
  },
  beforeDestroy() {
    this.$broadcastClient.leaveChannel(`ukasko.user.${this.getCurrentUserId}`);
  },
  computed: {
    ...mapGetters('currentUserModule', ['getCurrentUserId']),
  },
  methods: {
    ...mapActions('serverNotificationsModule', ['setNewNotification']),
  },
};
